<template>
		<div class="content-fr">
      <div class="" @click="back()" style="position: absolute;left: 30px;top: 30px;z-index: 100">
        <img style="width: 70px;" src="static/images/retrun.png">
      </div>

      <iframe
        v-if="token"
        class="iframe"
        :src="'https://dialog-games.gbgts.com/jump?token=' + token + '&Language=' + isEN + '&t=' + Date.now()"
        @load="onIframeLoad" scrolling="no"
      ></iframe>

<!--      <iframe-->
<!--        v-if="user_id"-->
<!--        class="iframe"-->
<!--        :src="'http://localhost:8081/pages/game/redBoxRain/index?user_id=' + user_id + '&lang=' + isEN + '&t=' + Date.now()"-->
<!--        @load="onIframeLoad"-->
<!--      ></iframe>-->
		</div>
</template>
<script>

export default {
    components:{

    },
    data() {

    return {
			info:{},
      user_id:'',
      invited_code:'',
      invitedAlert:'',
      answerReson:{},
      isEN:'bur',
      token:"",
		}
    },
	watch: {

	},
	computed:{
	},
    mounted() {

    },
    created(){
      this.$parent.loadModal(true);
      this.isEN = localStorage.getItem('lang')?localStorage.getItem('lang'):"bur"
      this.token = localStorage.getItem('token')?localStorage.getItem('token'):""
    },
  methods: {
      onIframeLoad(){
        this.$parent.loadModal(false);
      },
		  back(){
        this.$router.go(-1);
		  },
	}
}
</script>
<style>
  .iframe{width: 100%;height: 100%;border: none; overflow: hidden;}

</style>



// WEBPACK FOOTER //
// src/page/gameJump.vue